<!-- 带搜索项的输入框 -->
<template>
    <div>
        <el-form-item class="nameItem" :class="{ isError: isCheck }" prop="material">
            <template #label>
                <span style="color: #F56C6C">* </span>食材：
            </template>
            <el-input name="material" :class="{ isInputError: isCheck }" v-model="material" @input="searchMaterial"
                @focus="changeMaterialCheck(false)" clearable prefix-icon="el-icon-search" placeholder="请输入食材名称" />
            <div v-if="isCheck" class="errorMsg">*食材不能为空</div>
            <div v-if="material.length" class="searchContent">
                <div v-loading="isLoading" class="subContainer">
                    <div class="content">
                        <template v-if="materialList.length">
                            <div class="itemContent"
                                :class="{ 'selectItemContent': table.some(subitem => subitem.id === item.id) }"
                                v-for="item in materialList" :key="item.id" @click="toggleItem(item)">
                                {{ item.ingredientName }}
                            </div>
                        </template>
                        <div v-else class="emptyHint">数据为空</div>
                    </div>
                    <el-button class="okBtn" type="text" size="small" @click="material = ''">确定</el-button>
                </div>
            </div>
        </el-form-item>
        <template v-if="table.length">
            <el-table :data="table" max-height="250">
                <el-table-column prop="ingredientName" align="right" label="食材名称" />
                <el-table-column prop="name" align="center" label="比例">
                    <template slot-scope="scope">
                        <el-input-number style="width: 100%;" :value="scope.row.ratio" :controls="false" :precision="2"
                            :min="1" @input="val => changeRatio(val, scope.row.id)" />
                    </template>
                </el-table-column>
                <el-table-column prop="energy" align="right" label="能量预估">
                    <template slot-scope="scope">
                        {{ scope.row.handledKcal || 0 }} kcal
                    </template>
                </el-table-column>
                <el-table-column align="right" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="deleteRow(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="dec">总能量预估{{ allKcal }}kcal/100g</div>
        </template>
    </div>
</template>
<script>
import { calcEnergy } from "@/utils";
import { get } from "@/api/http"
export default {
    name: "CustomSerchInputItem",
    props: {
        isCheck: {
            type: Boolean,
            default: false
        },
        changeMaterialCheck: {
            type: Function,
            default: () => { }
        },
        tableProps: {
            type: Array,
            default: () => []
        }
    },
    mounted() {
        this.table = this.tableProps?.map(item => ({ ...item, ratio: item.proportion }));
        // 计算每个食材的能量
        let allRation = 0;
        this.tableProps?.forEach(item => {
            allRation += Number(item.proportion || '');
        });
        this.table = this.table.map(item => {
            const handledKcal = calcEnergy(item.ratio, allRation, item.energy);
            return Object.assign({}, item, { handledKcal });
        });
    },
    data() {
        return {
            material: '', // 食材名称
            table: [], // 比例食材列表
            materialList: [], // 食材列表
            isLoading: false // 查询食材中
        }
    },
    computed: {
        isSelected(item) {
            return this.table.some(subitem => subitem.id === item.id);
        },
        allKcal() { // 计算总能量
            let allKcal = 0;
            this.table.forEach(item => {
                allKcal += Number(item.handledKcal || 0);
            });
            return Math.round((allKcal + Number.EPSILON) * 100) / 100
        }
    },
    watch: {
        // 查询食材
        material(newVal) {
            if (newVal) {
                this.changeMaterialCheck(false);
            }
        },
    },
    methods: {
        // 查询食材列表
        async searchMaterial(val) {
            if (!val) {
                return;
            }
            try {
                this.isLoading = true;
                const result = await get(`/ingredient/list?pageNum=1&pageSize=1000&ingredientName=${val}&category=`);
                const { data: { list = [] } = {} } = result;
                this.materialList = list;
            } catch (error) {
                console.log(error);
            } finally {
                this.isLoading = false;
            }
        },
        // 切换选中的食材
        toggleItem(item) {
            const idList = this.table.map(subitem => subitem.id);
            if (idList.includes(item.id)) {
                this.table = this.table.filter(subitem => subitem.id !== item.id);
            } else {
                this.table.push(item);
                // 设置默认占比为1
                this.changeRatio(1, item.id);
            }
        },
        // 删除选中的药材
        deleteRow(row) {
            const { id = '' } = row;
            this.table = this.table.filter(subitem => subitem.id !== id);
            this.$emit("updataFn", this.table);
        },
        // 修改占比比例同时计算能量
        changeRatio(val, id) {
            let allRation = 0;
            this.table.forEach(item => {
                if (item.id !== id) {
                    allRation += Number(item.ratio || '');
                } else {
                    allRation += Number(val || '');
                }
            });
            this.table = this.table.map(item => {
                if (item.id !== id) {
                    const handledKcal = calcEnergy(item.ratio, allRation, item.energy);
                    return Object.assign({}, item, { handledKcal });
                } else {
                    const handledKcal = calcEnergy(val, allRation, item.energy);
                    return Object.assign({}, item, { ratio: val, handledKcal });
                }
            });
            this.$emit("updataFn", this.table);
        },
    },
};
</script>
<style lang="scss" scoped>
.nameItem {
    position: relative;

    .searchContent {
        position: absolute;
        background-color: #fff;
        height: 250px;
        z-index: 99;
        width: 100%;
        box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1), -2px 2px 5px rgba(0, 0, 0, 0.1), 0px 2px 5px rgba(0, 0, 0, 0.1);

        .subContainer {
            height: 250px;
            position: relative;

            .content {
                height: 222px;
                overflow-y: auto;

                .itemContent {
                    padding-left: 20px;
                    cursor: pointer;
                }

                .selectItemContent {
                    background: #00c6ff1a;
                }

            }
            .emptyHint {
                margin: auto;
                width: fit-content;
                margin-top: 30px;
            }

            .okBtn {
                position: absolute;
                bottom: 2px;
                right: 22px;
                z-index: 100;
            }
        }
    }

}

.isError {
    margin-bottom: 0;
}



.isInputError {
    border: 1px solid #F56C6C;
    border-radius: 4px;
}

.errorMsg {
    color: #F56C6C;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    padding-bottom: 4px;
}

.dec {
    margin: 10px 0;
}
</style>
